import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { Logo, NextStepButton } from "components";
import { SINGLE_INVOICE_PRICE_RESET, MOVE_TAB } from "actions";

class SingleInvoicePrice extends Component {
  moveToNextTab = () => {
    this.props.moveToNextTab();
  };
  resetSingleInvoice = () => {
    this.props.singleInvoicePriceReset();
    this.props.moveToSingleInvoiceStart();
  };
  render() {
    const props = this.props;

    const invoiceValue = Number.parseFloat(props.singleInvoiceAmount);
    const protectedAmount = Number.parseFloat(props.singleInvoiceAmountProtected);
    const protectedPercentage = (protectedAmount / invoiceValue) * 100;
    const protectionPrice = Number.parseFloat(props.singleInvoiceTotalPrice);

    const formatter = new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' });

    return (
      <div className="form_steps">
        <div className="form_steps--inner flex">
          <div className="full_column">
            <Logo />
            <div className="form_content">
              <div className="form_content">
                  {props.singleInvoiceStatus === "offered" && (
                    <React.Fragment>
                    <h2 className="form_content--title">
                      Great news! Cover is available on this invoice from our insurance partner <abbr title="Hokodo is a specialist provider of Invoice Insurance. Their cover is backed by Lloyd's of London. InvoiceInsure introduce customers to Hokodo who arrange and administer your cover.">Hokodo</abbr>
                    </h2>
                    <Box>
                      <TextBox>
                        <p>Your quote to cover this invoice:</p>
                        <IndentedLi>Your invoice value (excluding VAT): <strong>{formatter.format(invoiceValue)}</strong></IndentedLi>
                        <IndentedLi>Hokodo can protect {protectedPercentage.toFixed(0)}&#37;: <strong>{formatter.format(protectedAmount)}</strong></IndentedLi>
                        <IndentedLi>Your price to protect: <strong>{formatter.format(protectionPrice)}</strong></IndentedLi>
                        <p>Just click below to transfer to Hokodo and purchase.</p>
                      </TextBox>
                    </Box>
                    <NextStepButton
                          onClick={this.moveToNextTab}
                          text={"Purchase"}
                        />
                    </React.Fragment>
                  )}

                  {props.singleInvoiceStatus === "declined" && (
                  <React.Fragment>
                    <h2 className="form_content--title">
                     Unfortunately, our insurance partner Hokodo can't cover invoices like this just now.
                    </h2>
                    <Box>
                        <p>The reason they can't cover it is because: <strong>{props.singleInvoiceRejectionReason}</strong></p>
                        <Info>However, why not try another invoice?</Info>
                    </Box>
                    <NextStepButton
                    onClick={this.resetSingleInvoice}
                    customStyles={{ "max-width": "100% !important" }}
                    text="Try another invoice"
                    />
                  </React.Fragment>
                  )}
                
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
//<NextStepButton onClick={this.moveToNextTab} text={"Next step "} />

const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    singleInvoicePriceReset: () =>
      dispatch({ type: SINGLE_INVOICE_PRICE_RESET }),
    moveToSingleInvoiceStart: () =>
      dispatch({ type: MOVE_TAB, dir: "back", from: "single-invoice-company" }),
    moveToNextTab: () =>
      dispatch({ type: MOVE_TAB, dir: "next", from: ownProps.tab })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleInvoicePrice);

const Box = styled.div`
  background-color: #fff;
  padding: 20px;
  text-align: center;
  border: 1px solid #e3e3e3;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

  .p {
    margin-bottom: 10px;
  }
`;

const TextBox = styled.div`
  display: inline-block;
  text-align: left;
`;

const IndentedLi = styled.li`
  margin-left: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Info = styled.div`
  margin-top: 50px;
`;
